module.exports = __webpack_public_path__ + "assets/media/2.9d8eebfc.wav";